<script setup lang="ts">
/**
 * ThemeProvider · 主题上下文
 * ------------------------------------------------------------
 * 只做状态提供与持久化；切换入口在 PortalHeader「外观」面板
 * （明暗模式 + 语言，与原型 EMA_UI/主题机制对齐）。
 */
import { provide } from 'vue'
import { useTheme } from './useTheme'
import { useI18n } from '@/design/i18n'

const theme = useTheme()
const i18n = useI18n()
provide('theme', theme)
provide('i18n', i18n)
</script>

<template>
  <slot />
</template>
